import { useState } from "react";
import { toast } from "sonner";
import { RefreshCw, Trash2 } from "lucide-react";

// Universal cache controls — mounted in profile menus + settings across roles.
export default function AppCacheControls({ inline }) {
  const [busy, setBusy] = useState(false);

  const checkUpdates = async () => {
    setBusy(true);
    try {
      const reg = window.__ponderrSWReg || (navigator.serviceWorker && await navigator.serviceWorker.getRegistration());
      if (reg) { await reg.update(); toast.success("Checked for updates"); }
      else toast.info("Service worker not active yet");
    } catch { toast.error("Update check failed"); }
    finally { setBusy(false); }
  };

  const clearCache = async () => {
    setBusy(true);
    try {
      if ("caches" in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
      }
      // Preserve auth (cookie-based) + theme; drop only volatile UI cache keys.
      try {
        Object.keys(localStorage).forEach(k => {
          if (k.startsWith("rq-") || k.endsWith("_cache")) localStorage.removeItem(k);
        });
      } catch { /* ignore */ }
      toast.success("Cache cleared — reloading…");
      setTimeout(() => window.location.reload(), 500);
    } catch { toast.error("Could not clear cache"); setBusy(false); }
  };

  const cls = inline
    ? "flex flex-col gap-2"
    : "flex flex-col gap-1 p-2 min-w-[200px]";
  return (
    <div className={cls} data-testid="app-cache-controls">
      <button onClick={checkUpdates} disabled={busy} data-testid="cache-check-updates"
        className="flex items-center gap-2 text-sm px-3 py-2 rounded-lg border-2 pf-border hover:opacity-80">
        <RefreshCw size={15} className={busy ? "animate-spin" : ""} /> Check for Updates
      </button>
      <button onClick={clearCache} disabled={busy} data-testid="cache-clear-reload"
        className="flex items-center gap-2 text-sm px-3 py-2 rounded-lg border-2 pf-border bg-[#FCA5A5] hover:opacity-80">
        <Trash2 size={15} /> Clear App Cache &amp; Reload
      </button>
    </div>
  );
}
